/* eslint-disable camelcase */
import { combineReducers } from 'redux';

import categories from './categories';
import experts from './experts';
import followings from './followings';
import linked_events from './linked_events';
import links from './links';
import members from './members';
import partners from './partners';
import posts from './posts';
import social_links from './social_links';
import topics from './topics';

export default combineReducers({
  topics,
  followings,
  linked_events,
  categories,
  experts,
  partners,
  links,
  social_links,
  posts,
  members,
});
